//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { FileText, Folder } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getKey } from "../../helpers/sessionKey";
import GridIcon from "../../Icons/GridIcon";
import ListIcon from "../../Icons/ListIcon";
import SearchIcon from "../../Icons/SearchIcon";
import { classNames } from "../../utils/classNames";
import RenameFile from "../Folders/RenameFile";
import AddFolder from "../Reusable/AddFolder";
import FileOptions from "../Reusable/FileOptions";
import CustomFileViewer from "../Reusable/FileViewer";
import Modal from "../Reusable/Modal";
import Options from "../Reusable/OptionsPopOver";
import CreateFolder from "./CreateFolder";
import RenameFolder from "./RenameFolder";
import TableView from "./TableView";
import Search from "../Search";
import Preview from "../Reusable/Preview";

const Dashboard = (props: any) => {
  const {
    handleDeleteFolder,
    isDeleting,
    handleDeleteFile,
    isdeleteLoading,
    fileList,
    folderList,
  } = props;

  const [view, setView] = useState<"list" | "grid">(() => {
    const saved = localStorage.getItem("dashboardView");
    return saved === "grid" || saved === "list" ? saved : "list";
  });

  useEffect(() => {
    localStorage.setItem("dashboardView", view);
  }, [view]);

  const [qrImage, setQrImage] = useState<string | null>(null);
  const [openQrUploadPopup, setOpenQrUploadPopup] = useState(false);
  const [openRenameFilePopup, setOpenRenameFilePopup] = useState(false);
  const [openCreateFolderPopup, setOpenCreateFolderPopup] = useState(false);
  const [openRenameFolderPopup, setOpenRenameFolderPopup] = useState(false);
  const [openSearchPopup, setOpenSearchPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selected, setSelected] = useState({
    id: "",
    title: "",
  });
  const navigate = useNavigate();
  const user = getKey("user");

  return (
    <>
      <div className={tw`flex justify-between items-center`}>
        <AddFolder
          id={user || ""}
          setQrImage={setQrImage}
          setOpenQrUploadPopup={setOpenQrUploadPopup}
          qrImage={qrImage}
          setOpenCreateFolderPopup={setOpenCreateFolderPopup}
        />
        <div className={tw`flex gap-x-4 items-center`}>
          <div
            className={tw`grid grid-cols-2   border-1 border-gray-600 rounded-xl overflow-hidden`}
          >
            <button
              onClick={() => setView("list")}
              type="button"
              className={classNames(
                view === "list" ? tw`bg-gray-300` : tw``,
                tw`px-3 py-1 focus:outline-none`
              )}
            >
              <ListIcon />
            </button>
            <button
              onClick={() => setView("grid")}
              type="button"
              className={classNames(
                view === "grid" ? tw`bg-gray-300 ` : tw``,
                tw`px-3 py-1 focus:outline-none`
              )}
            >
              <GridIcon />
            </button>
          </div>
          <button
            type="button"
            onClick={() => setOpenSearchPopup(true)}
            className={tw`focus:outline-none`}
          >
            <SearchIcon />
          </button>
        </div>
      </div>
      {view === "grid" ? (
        <>
          {Array.isArray(folderList) && folderList?.length > 0 ? (
            <>
              <div className={tw`my-2`}>
                <h2 className={tw`text-lg font-semibold`}>Folders</h2>
                <div className={tw`grid grid-cols-5 gap-4 mt-2`}>
                  {folderList?.map((folder: any) => (
                    <div
                      key={folder.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`folder/${folder.id}`);
                      }}
                      className={tw`bg-[#DEDEDEC2]  cursor-pointer rounded p-4 flex items-center justify-between shadow-md hover:bg-gray-300 transition-colors`}
                    >
                      <div className={tw`flex items-center gap-3`}>
                        <Folder />
                        <p className={tw` truncate max-w-[120px]`}>
                          {folder?.title}
                        </p>
                      </div>
                      <Options
                        setSelected={setSelected}
                        folder={folder}
                        setOpenRenameFolderPopup={setOpenRenameFolderPopup}
                        handleDelete={handleDeleteFolder}
                        isdeleteLoading={isDeleting}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : null}
          {Array.isArray(fileList) && fileList?.length > 0 ? (
            <>
              <h2 className={tw`text-lg py-2 font-semibold`}>Files</h2>
              <div className={tw`grid grid-cols-5 gap-4 mt-2`}>
                {fileList?.map((item) => {
                  const title = item?.title || "";
                  const filePath = item?.file;

                  const extensionMatch = title.match(/\.(\w+)$/);
                  const fileType = extensionMatch
                    ? extensionMatch[1].toLowerCase()
                    : "";

                  return (
                    <button
                      key={item?.id}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedFile({
                          url: filePath,
                          title: title,
                          type: fileType,
                        });
                      }}
                      className={tw`bg-[#DEDEDEC2] focus:outline-none cursor-pointer hover:bg-gray-300 rounded-lg  shadow-md`}
                    >
                      <div className={tw`p-2 flex justify-between`}>
                        <p className={tw`text-sm truncate `}>{title}</p>
                        <FileOptions
                          setSelected={setSelected}
                          file={item}
                          setOpenRenameFolderPopup={setOpenRenameFilePopup}
                          handleDelete={handleDeleteFile}
                          isdeleteLoading={isdeleteLoading}
                        />
                      </div>
                      <CustomFileViewer
                        key={item?.id}
                        filePath={filePath}
                        fileType={fileType}
                      />
                    </button>
                  );
                })}
              </div>
            </>
          ) : null}
        </>
      ) : (
        <TableView
          setSelected={setSelected}
          setOpenRenameFolderPopup={setOpenRenameFolderPopup}
          handleDeleteFolder={handleDeleteFolder}
          isDeleting={isDeleting}
          handleDeleteFile={handleDeleteFile}
          setOpenRenameFilePopup={setOpenRenameFilePopup}
          isdeleteLoading={isdeleteLoading}
        />
      )}
      <Preview selectedFile={selectedFile} setSelectedFile={setSelectedFile} />
      <Modal
        isOpen={openCreateFolderPopup}
        title={"New Folder"}
        setIsOpen={setOpenCreateFolderPopup}
      >
        <CreateFolder setOpenCreateFolderPopup={setOpenCreateFolderPopup} />
      </Modal>
      <Modal
        isOpen={openRenameFolderPopup}
        title={"Rename"}
        setIsOpen={setOpenRenameFolderPopup}
      >
        <RenameFolder
          selected={selected}
          setOpenRenameFolderPopup={setOpenRenameFolderPopup}
        />
      </Modal>
      <Modal
        isOpen={openRenameFilePopup}
        title={"Rename"}
        setIsOpen={setOpenRenameFilePopup}
      >
        <RenameFile
          selected={selected}
          setOpenRenameFolderPopup={setOpenRenameFilePopup}
        />
      </Modal>
      <Modal
        title={"Search"}
        isOpen={openSearchPopup}
        setIsOpen={setOpenSearchPopup}
      >
        <Search setOpenSearchPopup={setOpenSearchPopup} />
      </Modal>
      <Modal
        title={"Scan QR to upload"}
        isOpen={openQrUploadPopup}
        setIsOpen={setOpenQrUploadPopup}
      >
        <div className={tw`mt-4 w-96`}>
          <img
            src={qrImage}
            alt="Generated QR Code"
            className={tw`w-full h-64 object-contain border p-2 rounded`}
          />
        </div>
      </Modal>
    </>
  );
};

export default Dashboard;
